import * as am5 from '@amcharts/amcharts5';
import {
  createChartRoot,
  createDateAxis,
  createLineSeries,
  createValueAxis,
  createXYChart,
  createXYCursor,
} from '../../../Charts/amcharts-xy';

export type ReferentChartPoint = { date: number; val: number };

export function createReferentChart(
  host: HTMLDivElement,
  data: ReferentChartPoint[],
  seriesLabel: string,
  onRangeSelect?: (debut: Date, fin: Date) => void,
): am5.Root {
  const root = createChartRoot(host);
  const chart = createXYChart(root, {
    enableHorizontalZoom: true,
    enableHorizontalPan: false,
    showAllSeriesTooltips: true,
    paddingBottom: 8,
  });
  const xAxis = createDateAxis(root, chart, {
    baseInterval: { timeUnit: 'minute', count: 10 },
  });
  const yAxis = createValueAxis(root, chart);
  const series = createLineSeries(root, chart, {
    name: seriesLabel,
    valueYField: 'val',
    color: 0x59c2a6,
    yAxis,
    xAxis,
    fillOpacity: 0.15,
    tooltipText: '{valueY}',
    data,
  });

  series.get('tooltip')?.label.adapters.add('text', (_text, target) => {
    const di = target.dataItem;
    if (!di) return _text ?? '';
    const x = di.get('valueX' as never) as number | undefined;
    const y = di.get('valueY' as never) as number | undefined;
    if (x == null || y == null) return _text ?? '';
    const d = new Date(x);
    const dateStr = d.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' })
      + ' ' + d.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
    const valStr = y.toLocaleString('fr-FR', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
    return `${seriesLabel}\n${dateStr}\n${valStr}`;
  });

  createXYCursor(root, chart, {
    snapToSeries: [series],
    behavior: 'selectX',
    showHorizontalLine: false,
    onRangeSelect,
  });
  chart.appear(600, 100);
  return root;
}
